/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetFollowUpNecessityJudgmentResult200Response } from '../models';
/**
 * FollowUpNecessityJudgmentResultApi - axios parameter creator
 * @export
 */
export const FollowUpNecessityJudgmentResultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 追客要否判断結果取得API
         * @summary 追客要否判断結果取得API
         * @param {number} zoomPhoneResultId ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowUpNecessityJudgmentResult: async (zoomPhoneResultId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoomPhoneResultId' is not null or undefined
            assertParamExists('getFollowUpNecessityJudgmentResult', 'zoomPhoneResultId', zoomPhoneResultId)
            const localVarPath = `/api/user/zoom_phone_results/{zoomPhoneResultId}/transcription/follow_up_necessity_judgment_result`
                .replace(`{${"zoomPhoneResultId"}}`, encodeURIComponent(String(zoomPhoneResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 追客要否判断結果生成API
         * @summary 追客要否判断結果生成API
         * @param {number} zoomPhoneResultId ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postJudgeFollowUpNecessity: async (zoomPhoneResultId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoomPhoneResultId' is not null or undefined
            assertParamExists('postJudgeFollowUpNecessity', 'zoomPhoneResultId', zoomPhoneResultId)
            const localVarPath = `/api/user/zoom_phone_results/{zoomPhoneResultId}/transcription/judge_follow_up_necessity`
                .replace(`{${"zoomPhoneResultId"}}`, encodeURIComponent(String(zoomPhoneResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FollowUpNecessityJudgmentResultApi - functional programming interface
 * @export
 */
export const FollowUpNecessityJudgmentResultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FollowUpNecessityJudgmentResultApiAxiosParamCreator(configuration)
    return {
        /**
         * 追客要否判断結果取得API
         * @summary 追客要否判断結果取得API
         * @param {number} zoomPhoneResultId ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFollowUpNecessityJudgmentResult(zoomPhoneResultId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFollowUpNecessityJudgmentResult200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFollowUpNecessityJudgmentResult(zoomPhoneResultId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 追客要否判断結果生成API
         * @summary 追客要否判断結果生成API
         * @param {number} zoomPhoneResultId ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postJudgeFollowUpNecessity(zoomPhoneResultId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postJudgeFollowUpNecessity(zoomPhoneResultId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FollowUpNecessityJudgmentResultApi - factory interface
 * @export
 */
export const FollowUpNecessityJudgmentResultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FollowUpNecessityJudgmentResultApiFp(configuration)
    return {
        /**
         * 追客要否判断結果取得API
         * @summary 追客要否判断結果取得API
         * @param {number} zoomPhoneResultId ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowUpNecessityJudgmentResult(zoomPhoneResultId: number, options?: any): AxiosPromise<GetFollowUpNecessityJudgmentResult200Response> {
            return localVarFp.getFollowUpNecessityJudgmentResult(zoomPhoneResultId, options).then((request) => request(axios, basePath));
        },
        /**
         * 追客要否判断結果生成API
         * @summary 追客要否判断結果生成API
         * @param {number} zoomPhoneResultId ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postJudgeFollowUpNecessity(zoomPhoneResultId: number, options?: any): AxiosPromise<void> {
            return localVarFp.postJudgeFollowUpNecessity(zoomPhoneResultId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FollowUpNecessityJudgmentResultApi - interface
 * @export
 * @interface FollowUpNecessityJudgmentResultApi
 */
export interface FollowUpNecessityJudgmentResultApiInterface {
    /**
     * 追客要否判断結果取得API
     * @summary 追客要否判断結果取得API
     * @param {number} zoomPhoneResultId ZoomPhoneResult ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FollowUpNecessityJudgmentResultApiInterface
     */
    getFollowUpNecessityJudgmentResult(zoomPhoneResultId: number, options?: AxiosRequestConfig): AxiosPromise<GetFollowUpNecessityJudgmentResult200Response>;

    /**
     * 追客要否判断結果生成API
     * @summary 追客要否判断結果生成API
     * @param {number} zoomPhoneResultId ZoomPhoneResult ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FollowUpNecessityJudgmentResultApiInterface
     */
    postJudgeFollowUpNecessity(zoomPhoneResultId: number, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for getFollowUpNecessityJudgmentResult operation in FollowUpNecessityJudgmentResultApi.
 * @export
 * @interface FollowUpNecessityJudgmentResultApiGetFollowUpNecessityJudgmentResultRequest
 */
export interface FollowUpNecessityJudgmentResultApiGetFollowUpNecessityJudgmentResultRequest {
    /**
     * ZoomPhoneResult ID
     * @type {number}
     * @memberof FollowUpNecessityJudgmentResultApiGetFollowUpNecessityJudgmentResult
     */
    readonly zoomPhoneResultId: number
}

/**
 * Request parameters for postJudgeFollowUpNecessity operation in FollowUpNecessityJudgmentResultApi.
 * @export
 * @interface FollowUpNecessityJudgmentResultApiPostJudgeFollowUpNecessityRequest
 */
export interface FollowUpNecessityJudgmentResultApiPostJudgeFollowUpNecessityRequest {
    /**
     * ZoomPhoneResult ID
     * @type {number}
     * @memberof FollowUpNecessityJudgmentResultApiPostJudgeFollowUpNecessity
     */
    readonly zoomPhoneResultId: number
}

/**
 * FollowUpNecessityJudgmentResultApi - object-oriented interface
 * @export
 * @class FollowUpNecessityJudgmentResultApi
 * @extends {BaseAPI}
 */
export class FollowUpNecessityJudgmentResultApi extends BaseAPI implements FollowUpNecessityJudgmentResultApiInterface {
    /**
     * 追客要否判断結果取得API
     * @summary 追客要否判断結果取得API
     * @param {FollowUpNecessityJudgmentResultApiGetFollowUpNecessityJudgmentResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FollowUpNecessityJudgmentResultApi
     */
    public getFollowUpNecessityJudgmentResult(requestParameters: FollowUpNecessityJudgmentResultApiGetFollowUpNecessityJudgmentResultRequest, options?: AxiosRequestConfig) {
        return FollowUpNecessityJudgmentResultApiFp(this.configuration).getFollowUpNecessityJudgmentResult(requestParameters.zoomPhoneResultId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 追客要否判断結果生成API
     * @summary 追客要否判断結果生成API
     * @param {FollowUpNecessityJudgmentResultApiPostJudgeFollowUpNecessityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FollowUpNecessityJudgmentResultApi
     */
    public postJudgeFollowUpNecessity(requestParameters: FollowUpNecessityJudgmentResultApiPostJudgeFollowUpNecessityRequest, options?: AxiosRequestConfig) {
        return FollowUpNecessityJudgmentResultApiFp(this.configuration).postJudgeFollowUpNecessity(requestParameters.zoomPhoneResultId, options).then((request) => request(this.axios, this.basePath));
    }
}
